import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PuzzlePage.css';
import img1 from './images/img1.PNG';
import bg3 from './images/bg3.webp';
// import FeelModal from './components/FeelModal';
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
import { useAudio } from './AudioContext';
// const sweet = withReactContent(Swal);

const ROWS = 3; // 3x3
const COLS = 3;
const PIECE_SIZE = 140; // px on board

function shuffle(array) {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function PuzzlePage() {
  const navigate = useNavigate();
  const [order, setOrder] = useState(() => shuffle([...Array(ROWS*COLS).keys()]));
  const [selectedIndex, setSelectedIndex] = useState(null); // Index piece yang dipilih untuk swap
  const [win, setWin] = useState(false);
  // const [showCamera, setShowCamera] = useState(false);
  // const [photo, setPhoto] = useState(null); // dataURL
  // const [sending, setSending] = useState(false);
  const boardRef = useRef(null);
  // const [feelModalOpen, setFeelModalOpen] = useState(false);
  // const [feelInput, setFeelInput] = useState('');
  // const [afterFeel, setAfterFeel] = useState(null);
  const { playSound2 } = useAudio();

  useEffect(() => {
    // Switch to sound2 when entering PuzzlePage
    playSound2();
  }, [playSound2]);

  useEffect(() => {
    const ok = order.every((origIndex, posIndex) => origIndex === posIndex);
    setWin(ok);
  }, [order]);

  // Redirect to /surprise when puzzle is correct
  useEffect(() => {
    if (win) {
      // Small delay to show win message briefly, then redirect
      const timer = setTimeout(() => {
        navigate('/surprise');
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [win, navigate]);

  const pieces = useMemo(() => {
    const arr = [];
    for (let r=0; r<ROWS; r++) {
      for (let c=0; c<COLS; c++) {
        arr.push({ r, c, idx: r*COLS + c });
      }
    }
    return arr;
  }, []);

  // Tap-to-swap handler
  const handlePieceClick = (clickedIndex) => {
    if (selectedIndex === null) {
      // First tap: select this piece
      setSelectedIndex(clickedIndex);
    } else if (selectedIndex === clickedIndex) {
      // Tap same piece: deselect
      setSelectedIndex(null);
    } else {
      // Second tap on different piece: swap
      const newOrder = order.slice();
      [newOrder[selectedIndex], newOrder[clickedIndex]] = [newOrder[clickedIndex], newOrder[selectedIndex]];
      setOrder(newOrder);
      setSelectedIndex(null);
    }
  };

  const handleKeyReset = () => setOrder(shuffle([...Array(ROWS*COLS).keys()]));

  return (
    <div className="puzzle-bg" style={{ backgroundImage: `url(${bg3})` }}>
      <div className="puzzle-container">
        <div className="puzzle-title">Puzzle Time💜</div>
        <div className="puzzle-sub"></div>
        <div className="puzzle-board" ref={boardRef}>
          {pieces.map((p, visualIndex) => {
            const origIndex = order[visualIndex];
            const srcX = (origIndex % COLS);
            const srcY = Math.floor(origIndex / COLS);
            const isSelected = selectedIndex === visualIndex;
            return (
              <div
                key={visualIndex}
                className={"puzzle-cell" + (isSelected ? " puzzle-cell-selected" : "")}
                onClick={() => handlePieceClick(visualIndex)}
                style={{ cursor: 'pointer' }}
              >
                <JigsawPiece
                  r={srcY}
                  c={srcX}
                  rows={ROWS}
                  cols={COLS}
                  isSelected={isSelected}
                />
              </div>
            );
          })}
        </div>
        <div className="puzzle-actions">
          <button className="puzzle-btn" onClick={handleKeyReset}>Shuffle</button>
          {win && <div className="puzzle-win">yay! Correct! 🎉</div>}
        </div>
      </div>

      {/* Commented out camera and feel modal functionality */}
      {/* {showCamera && (
        <CameraModal
          onClose={() => { setShowCamera(false); setPhoto(null); }}
          photo={photo}
          setPhoto={setPhoto}
          sending={sending}
          onSend={async (dataUrl) => {
            try {
              setSending(true);
              const feeling = await new Promise(resolve => {
                setFeelModalOpen(true);
                setFeelInput('');
                setAfterFeel(()=>v=>resolve(v||''));
              });
              const res = await fetch('https://api.laviopaperie.com/upload-photo', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: dataUrl, feeling }),
              });
              if (!res.ok) throw new Error('Failed uploading to server');
              setShowCamera(false);
              setPhoto(null);
              setTimeout(async () => {
                await sweet.fire({
                  title: 'Maacih sayang🫶🏻',
                  html: "Let's go next!",
                  timer: 1500,
                  showConfirmButton: false,
                  background: '#fef8ff',
                  color: '#7b64e8',
                  toast: true,
                  position: 'top',
                  showClass: { popup: 'swal-pop-in' },
                  hideClass: { popup: 'swal-pop-out' }
                });
                navigate('/surprise');
              }, 10);
            } catch (e) {
              alert('Gagal upload foto: ' + e.message);
            } finally {
              setSending(false);
            }
          }}
        />
      )}
      <FeelModal open={feelModalOpen} value={feelInput} onChange={setFeelInput}
        onCancel={()=>{setFeelModalOpen(false);afterFeel&&afterFeel('')}}
        onSend={()=>{setFeelModalOpen(false);afterFeel&&afterFeel(feelInput)}} /> */}
    </div>
  );
}

function JigsawPiece({ r, c, rows, cols, isSelected }) {
  // gridSize = parent size (100%), each piece=1/3 lebar board
  // Each piece window: x=[c/cols, (c+1)/cols), y likewise
  return (
    <div
      className={'puzzle-piece' + (isSelected ? ' puzzle-piece-selected' : '')}
      style={{ width: '100%', height: '100%', position: 'relative' }}
    >
      {isSelected && (
        <div className="puzzle-piece-overlay" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(138, 91, 217, 0.3)',
          border: '3px solid #8a5bd9',
          borderRadius: '10px',
          zIndex: 10,
          pointerEvents: 'none',
          boxSizing: 'border-box'
        }} />
      )}
      <svg className="piece-svg" viewBox="0 0 100 100" width="100%" height="100%">
        <defs>
          <clipPath id={`clip-${r}-${c}`} >
            {/* Path tetap ngikutin kotak penuh, lalu di-child grid */}
            <rect x="0" y="0" width="100" height="100" rx="10" ry="10" />
          </clipPath>
        </defs>
        <image
          href={img1}
          x={-c * 100}
          y={-r * 100}
          width={cols * 100}
          height={rows * 100}
          clipPath={`url(#clip-${r}-${c})`}
          preserveAspectRatio="none"
        />
        <rect width={100} height={100} fill="transparent" stroke="#e3cffb" strokeWidth="1.1" rx="10" ry="10" />
      </svg>
    </div>
  );
}

// Commented out CameraModal component
/* function CameraModal({ onClose, photo, setPhoto, onSend, sending }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const isSecure = useMemo(() => {
    if (window.isSecureContext) return true;
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1';
  }, []);

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
  };

  const startCamera = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setError('Perangkat ini tidak mendukung kamera (navigator.mediaDevices tidak ada).');
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const constraints = {
        video: {
          facingMode: { ideal: 'user' },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        },
        audio: false
      };
      const media = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = media;
      if (videoRef.current) {
        const video = videoRef.current;
        video.srcObject = media;
        video.muted = true;
        video.setAttribute('playsinline', 'true');
        video.style.transform = 'scaleX(-1)'; // Mirror video
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          await playPromise.catch(() => {});
        }
      }
      setLoading(false);
    } catch (e) {
      let msg = 'Kamera tidak tersedia atau izin ditolak';
      if (e && e.name) {
        if (e.name === 'NotAllowedError' || e.name === 'PermissionDeniedError') msg = 'Izin kamera ditolak. Izinkan akses kamera di browser.';
        else if (e.name === 'NotFoundError' || e.name === 'DevicesNotFoundError') msg = 'Tidak ada kamera yang terdeteksi.';
        else if (e.name === 'NotReadableError') msg = 'Kamera sedang digunakan aplikasi lain.';
        else if (e.name === 'OverconstrainedError') msg = 'Kamera tidak mendukung resolusi yang diminta.';
        else if (e.name === 'SecurityError') msg = 'Akses kamera diblokir oleh kebijakan keamanan browser.';
      }
      setError(msg);
      stopStream();
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!photo && isSecure) {
      startCamera();
    } else if (!isSecure) {
      setError('Kamera membutuhkan koneksi aman (https) atau jalankan melalui http://localhost.');
    }
    return () => {
      stopStream();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photo, isSecure]);

  const takePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const w = video.videoWidth || 640;
    const h = video.videoHeight || 480;
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.save();
    // Flip horizontally for mirror effect
    ctx.translate(w, 0);
    ctx.scale(-1, 1);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0,0,w,h);
    ctx.drawImage(video, 0, 0, w, h);
    ctx.restore();
    ctx.save();
    // Overlay frame
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.82)';
    ctx.fillRect(0, h-72, w, 72);
    ctx.fillStyle = '#8a5bd9';
    ctx.font = 'bold 30px Nunito, Arial';
    ctx.fillText('what you feel right now?', 20, h-26);
    ctx.restore();
    const dataUrl = canvas.toDataURL('image/png');
    setPhoto(dataUrl);
    stopStream();
  };

  const retake = () => {
    setPhoto(null);
    setError(null);
    stopStream();
    if (isSecure) {
      startCamera();
    }
  };

  const handleClose = () => {
    stopStream();
    setPhoto(null);
    setError(null);
    onClose();
  };

  return (
    <div className="cam-overlay">
      <div className="cam-modal">
        <button className="cam-close" onClick={handleClose} aria-label="close">✕</button>
        <div className="cam-title">Smile! 📷</div>
        {!photo ? (
          <div className="cam-content">
            {error && <div className="cam-error">{error}</div>}
            {!isSecure && (
              <div className="cam-hint">Pastikan kamu menjalankan aplikasi lewat https atau http://localhost.</div>
            )}
            {!loading && !streamRef.current && isSecure && (
              <div className="cam-start">
                <button className="puzzle-btn" onClick={startCamera}>Aktifkan Kamera</button>
              </div>
            )}
            {loading && <div className="cam-hint">Mengaktifkan kamera...</div>}
            {streamRef.current && !loading && !error && (
              <video ref={videoRef} className="cam-video mirror-video" playsInline muted autoPlay />
            )}
            <div className="cam-actions">
              <button className="puzzle-btn" onClick={takePhoto} disabled={!streamRef.current || !!error}>Take Photo</button>
            </div>
          </div>
        ) : (
          <div className="cam-content">
            <img src={photo} alt="preview" className="cam-preview mirror-video" />
            <div className="cam-actions">
              <button className="puzzle-btn ghost" onClick={retake}>Retake</button>
              <button className="puzzle-btn" disabled={sending} onClick={() => onSend(photo)}>{sending ? 'Sending...' : 'Send to Revi'}</button>
            </div>
          </div>
        )}
        <canvas ref={canvasRef} style={{display:'none'}} />
      </div>
    </div>
  );
} */
